/* =========================================================================
   PetLab Presell — Scroll Navigation (v5 - capture-phase)

   Uses CAPTURE-PHASE click listener so the theme can't kill our event
   via stopPropagation() in the bubble phase.

   Finds the target by href, preferring the -container id over the bare id,
   because the bare-id elements are absolutely-positioned anchor divs that
   float at y=0 and don't reflect the section's real position.
   ========================================================================= */
(function () {
  function getTargetFromHref(href) {
    if (!href || href.charAt(0) !== '#' || href.length < 2) return null;
    var id = href.slice(1);
    return document.getElementById(id + '-container') ||
           document.getElementById(id) ||
           null;
  }

  function doScroll(btn) {
    var href = btn.getAttribute('href') || '';
    var targetEl = getTargetFromHref(href);
    if (!targetEl) return false;

    var offset = parseInt(btn.getAttribute('data-scroll-offset'), 10);
    if (isNaN(offset)) offset = 80;

    var rectTop = targetEl.getBoundingClientRect().top;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var destination = rectTop + scrollY - offset;

    try {
      window.scrollTo({ top: destination, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, destination);
    }
    return true;
  }

  // Compatibility: keep global callable from inline onclick
  window.petlabScrollTo = function (btn, evt) {
    var e = evt || window.event;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    return doScroll(btn);
  };

  // CAPTURE PHASE (the `true` third arg). This runs before ANY bubble-phase
  // listener, including any theme listener that calls stopPropagation().
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('a[href^="#"]');
    if (!btn) return;
    if (!getTargetFromHref(btn.getAttribute('href'))) return;
    evt.preventDefault();
    evt.stopPropagation();
    doScroll(btn);
  }, true);
})();